module.exports = "<div class=\"pt-6 text-center\">\n  <app-mission></app-mission>\n  <app-how-it-works></app-how-it-works>\n  <app-aboutus></app-aboutus>\n  <app-contact-us></app-contact-us>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landingpage/landingpage.component.html
// module id = 222
// module chunks = 1